import React from "react";
import { string } from "prop-types";

import * as S from "./styled";

const AgentBanner = ({ children, className }) => (
  <S.Container className={className}>
    <S.Text>{children}</S.Text>
  </S.Container>
);

AgentBanner.propTypes = {
  children: string.isRequired,
  className: string
};

AgentBanner.defaultProps = {
  className: ""
};

export default AgentBanner;
